import React, {Component} from "react";
import MaterialTable, {MTableCell} from "material-table";
import {
    tsToDate, formatDateTime
} from "../components/Utilities/DateTimeUtils";
import {handleError, pageLoaded} from "../components/Utilities/OtherUtils";
import {getColumns} from "../components/FeedbackComps/DebateResultsColumns";
import {get_user_debate_results, set_motion} from "../Backend/userBackendFunctions";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import {NewDebateResultForm} from "../components/DebateResults/NewDebateResultForm";
import Button from "@material-ui/core/Button";
import {add_custom_result} from "../Backend/feedbackBackendFunctions";

/**
 * This page allows admins to view and analyze personal information and performance of the entire club's users
 * Consisted of three main components:
 * * Title: A toolbar with filters and actions
 * * Columns: Two arrays - one with personal info columns (email, phone number etc.) and one with
 *            a column per event (excluding lessons)
 * * Table Data: An array of rows. 3 Rows per User X Event.
 *               First row (score) is always visible, other two are expandable (chair+feedback and position)
 *
 * The table is based on material-table open source project: https://material-table.com/#/
 */
export class DebateResultsPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            openDialog: false,
            columns: []
        };
        this.refresh = this.refresh.bind(this);
        this.setMotion = this.setMotion.bind(this);
        this.closeAddResultDialog = this.closeAddResultDialog.bind(this);
        this.openAddResultDialog = this.openAddResultDialog.bind(this);
        this.addCustomResult = this.addCustomResult.bind(this);
    }

    openAddResultDialog() {
        this.setState({openDialog: true});
    }

    addCustomResult(result) {
        let chair = this.convertToRealUser(result.chair);
        let partner = this.convertToRealUser(result.partner);
        let json = {
            chair: chair.uid,
            chair_name_eng: chair.full_name_eng,
            chair_name_heb: chair.full_name_heb,
            info_slide: result.info_slide,
            motion: result.motion,
            partner: partner.uid,
            partner_name_eng: partner.full_name_eng,
            partner_name_heb: partner.full_name_heb,
            position: result.position.title,
            rank: parseInt(result.rank.rank),
            speaker_points: result.speaker_points,
            time: result.time
        };
        this.setState({openDialog: false, loading: true});
        add_custom_result(json)
            .then(_ => {
                this.setState({loading: false});
                window.location.href = '/results';
            })
            .catch(e => {
                handleError(e);
                this.setState({loading: false})
            });
    }

    convertToRealUser(fakeUser) {
        if (fakeUser.hasOwnProperty('uid')) {
            return fakeUser;
        }
        return {
            uid: fakeUser.id || "",
            full_name_eng: fakeUser.full_name_eng || "",
            full_name_heb: fakeUser.full_name_eng || ""
        }
    }

    closeAddResultDialog() {
        this.setState({openDialog: false});
    }

    componentDidMount() {
        if (pageLoaded("results")) {
            this.props.onLoad();
            this.refresh();
        }
        window.setMotion = this.setMotion;
    }

    setMotion(dateString, infoSlide, motion) {
        let eventId = this.state.tableData.filter(x => x.time === dateString)[0].id;
        set_motion(eventId, infoSlide, motion);
    }

    refresh() {
        const debaterColumns = getColumns();
        get_user_debate_results()
            .then(results => {
                this.setState(
                    {
                        loading: false,
                        tableData: this.convertData(results),
                        columns: debaterColumns
                    }
                );
            });
    }

    convertData(results) {
        return Object
            .entries(results)
            .map(entry => ({id: entry[0], ...entry[1]}))
            .sort((a, b) => b.time - a.time)
            .map(entry => {
                entry.time = formatDateTime(tsToDate(entry.time));
                entry.rank = this.convertRank(entry.rank);
                entry.speaker_points = entry.speaker_points === 0 ? "" : entry.speaker_points;
                return entry;
            });
    }

    convertRank(rank) {
        switch (rank) {
            case 1:
                return "1st";
            case 2:
                return "2nd";
            case 3:
                return "3rd";
            case 4:
                return "4th";
            default:
                return "";
        }
    }

    render() {
        return (
            <div style={{marginLeft: "5%", marginRight: "5%", marginTop: "5%"}}>

                <link
                    rel="stylesheet"
                    href="https://fonts.googleapis.com/icon?family=Material+Icons"
                />

                {/*This is really weird, but DO NOT REMOVE THIS <br/>*/}
                <br/>

                <Dialog
                    open={this.state.openDialog}
                    onClose={this.closeAddResultDialog}>
                    <DialogContent>
                        <NewDebateResultForm
                            onClose={() => this.closeAddResultDialog()}
                            onSubmit={result => this.addCustomResult(result)}
                        />
                    </DialogContent>
                </Dialog>


                <MaterialTable
                    components={{
                        Cell: props => {
                            return <MTableCell {...props} />;
                        }
                    }}
                    icons={{SortArrow: () => <span/>}}

                    isLoading={this.state.loading}
                    columns={this.state.columns}
                    data={this.state.tableData}
                    title="Debate Results"
                    options={{
                        search: false,
                        sorting: true,
                        filtering: false,
                        columnsButton: false,
                        exportButton: false, //TODO: My export function
                        doubleHorizontalScroll: true,
                        emptyRowsWhenPaging: false,
                        pageSizeOptions: [],
                        pageSize: 100
                    }}
                />
                <Button onClick={() => this.openAddResultDialog()}
                        style={{margin: 10}}
                        variant="contained"
                        color="primary">
                    Add Entry
                </Button>
            </div>
        );
    }
}
